var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineLinkCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.68 15.21c-.81-.3-1.49-.89-1.92-1.66-1-1.8-.38-4.15 1.37-5.24l2.34-1.45c.86-.53 1.87-.69 2.83-.44.96.25 1.77.88 2.26 1.76 1 1.8.38 4.15-1.37 5.24l-.26.19a.76.76 0 0 1-1.05-.17.76.76 0 0 1 .17-1.05l.31-.22c1.12-.7 1.5-2.15.89-3.26-.29-.52-.76-.89-1.32-1.04-.56-.15-1.15-.05-1.66.26L7.93 9.58c-1.08.67-1.46 2.12-.85 3.24.25.45.65.8 1.13.98.39.14.59.57.44.96-.11.31-.4.5-.71.5-.09 0-.17-.01-.26-.05z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 17.53c-.96-.25-1.77-.88-2.25-1.76-1-1.8-.38-4.15 1.37-5.24l.26-.19a.76.76 0 0 1 1.05.17c.24.34.16.81-.17 1.05l-.31.22c-1.12.7-1.5 2.15-.89 3.26.29.52.76.89 1.32 1.04.56.15 1.15.05 1.66-.26l2.34-1.45c1.08-.67 1.46-2.12.85-3.24-.25-.45-.65-.8-1.13-.98a.736.736 0 0 1-.44-.96c.14-.39.57-.59.96-.44.81.3 1.49.89 1.92 1.66 1 1.8.38 4.15-1.37 5.24l-2.34 1.45c-.59.36-1.25.55-1.92.55-.3 0-.61-.04-.91-.12z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12C1.25 6.07 6.07 1.25 12 1.25S22.75 6.07 22.75 12 17.93 22.75 12 22.75 1.25 17.93 1.25 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75 2.75 6.9 2.75 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineLinkCircle);
export default __webpack_public_path__ + "static/media/vuesax-outline-link-circle.90f92ed6ca46beadc01f9d816f22453f.svg";
export { ForwardRef as ReactComponent };